// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1sNFK","bigColWidth":"Table_bigColWidth__3JH75","biggerColWidth":"Table_biggerColWidth__1nwYK","row":"Table_row__XWxzk","col":"Table_col__3WZYL"};